module.exports = __webpack_public_path__ + "img/1500810490.e0538dc0.jpg";